// extracted by mini-css-extract-plugin
module.exports = {"circle":"SequenceSelector-module__circle___2rqsB","value":"SequenceSelector-module__value___SEJ6q","opacity25":"SequenceSelector-module__opacity25___3aDLu"};